// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media(max-width: 1200px){.SideCart{display:none}}`, "",{"version":3,"sources":["webpack://./src/Cart/cart.scss"],"names":[],"mappings":"AAGA,0BACI,UACI,YAAA,CAAA","sourcesContent":["\n\n\n@media (max-width: 1200px) {\n    .SideCart{\n        display:  none;\n    }\n        \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
